import sdkInstanceProvider from "../sdk/sdkInstanceProvider";

export async function getCustomerSegments(isAuthenticated) {
  if (!isAuthenticated) {
    return [];
  }

  try {
    const { getSegments } = await sdkInstanceProvider("audience");
    const segments = await getSegments();

    return segments.map(segment => segment.segmentId);
  } catch (_) {
    return [];
  }
}
